<template>
    <van-dialog 
      getContainer="body"
      v-model="opened" 
      :title="opts.type + '提醒'" 
      class="end-cards-confirm-dialog"    
      :showConfirmButton="false">
      <div class="end-cards-confirm-dialog-contain">
        <div >{{opts.studentName}}的{{opts.zeroCourseStrs}}{{opts.type}}后剩余数量为0，是否要同时停用上课卡？</div>
        <div class="tips">
          停用后上课卡关联的课消记录将无法修改，且不再参与费用预警
        </div>
        <van-button
          block
          type="default"
          @click="confirm(1)"
          size="large"
          style="color: var(--c1)"
          class="van-dialog__confirm van-hairline--top"
          >
          {{opts.type}}并停用上课卡
        </van-button>
        <van-button
          block
          type="default"
          @click="confirm(0)"
          size="large"
          class="van-dialog__confirm van-hairline--top"
          >
          仅{{opts.type}}
        </van-button>
        <van-button
          block
          type="default"
          @click="cancel"
          size="large"
          style="color: var(--g8)"
          class="van-dialog__confirm van-hairline--top"
          >
          取消
        </van-button>
      </div>
    </van-dialog>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      opts: {
        type: '退费',
        studentName: '小A',
        zeroCourseStrs: '',
      },
    };
  },
  methods: {
    show(opts) {
      this.opened = true;
      Object.assign(this.opts, opts);
      return new Promise((resolve,reject) => {
        this._resolve = resolve;
        this._reject = reject;
      });
    },
    confirm (val) {
      this._resolve(val);
      this.opened = false;
    },
    cancel () {
      this._reject('取消操作');
      this.opened = false;
    }
  },
};
</script>

<style lang="scss">
.end-cards-confirm-dialog-contain{
  margin: calc(var(--gap) * 10) 0 0;
  color: var(--g7);
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  .tips{
    margin: calc(var(--gap) * 8) 0 calc(var(--gap) * 16);
    color: var(--g6);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
  >div{
    padding: 0 calc(var(--gap) * 24);
  }
}
</style>